import React from "react";
import { LogoMark } from "./LogoMark";

const FOOTER_COLUMNS = [
	{
		title: "Product",
		links: [
			{ label: "Features", href: "#features" },
			{ label: "Pricing", href: "#pricing" },
			{ label: "Chrome Web Store", href: "#" },
			{ label: "Changelog", href: "#" },
		],
	},
	{
		title: "Resources",
		links: [
			{ label: "Documentation", href: "#" },
			{ label: "FAQ", href: "#faq" },
			{ label: "API Reference", href: "#" },
			{ label: "Status", href: "#" },
		],
	},
	{
		title: "Company",
		links: [
			{ label: "About", href: "#" },
			{ label: "Privacy Policy", href: "#" },
			{ label: "Terms of Service", href: "#" },
			{ label: "Contact", href: "#" },
		],
	},
];

export function Footer() {
	return (
		<footer className="border-t border-white/5 bg-zinc-950/80">
			<div className="mx-auto max-w-7xl px-6 py-16">
				<div className="grid grid-cols-2 gap-8 md:grid-cols-4">
					{/* Brand Column */}
					<div className="col-span-2 md:col-span-1">
						<a href="https://www.comps.red" className="flex items-center gap-2.5">
							<LogoMark size={24} />
							<span className="text-lg font-bold tracking-tight text-white">
								COMPS<span className="text-[#db241e]">.red</span>
							</span>
						</a>
						<p className="mt-3 text-sm font-medium text-zinc-400">
							.Red — Real Estate, Decentralized.
						</p>
						<p className="mt-2 text-sm leading-relaxed text-zinc-500">
							The real estate notebook for professionals, buyers, and sellers.
						</p>
					</div>

					{/* Link Columns */}
					{FOOTER_COLUMNS.map((col) => (
						<div key={col.title}>
							<h3 className="mb-4 text-sm font-semibold text-zinc-300">
								{col.title}
							</h3>
							<ul className="space-y-3">
								{col.links.map((link) => (
									<li key={link.label}>
										<a
											href={link.href}
											className="text-sm text-zinc-500 transition-colors hover:text-zinc-300"
										>
											{link.label}
										</a>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				{/* Bottom Bar */}
				<div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 md:flex-row">
					<p className="text-sm text-zinc-600">
						&copy; {new Date().getFullYear()} COMPS.red — Real Estate, Decentralized. All rights reserved.
					</p>
					<div className="flex gap-6">
						<a href="#" className="text-zinc-600 transition-colors hover:text-zinc-400">
							<span className="sr-only">Twitter</span>
							<svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
								<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
							</svg>
						</a>
						<a href="#" className="text-zinc-600 transition-colors hover:text-zinc-400">
							<span className="sr-only">GitHub</span>
							<svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
								<path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
							</svg>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}
